import { Heading, Subheading } from "../../../../design/heading";
import { Divider } from "../../../../design/divider";
import { Link } from "../../../../design/link";
import Breadcrumbs from "../../../../components/Breadcrumbs";
import { Button } from "../../../../design/button";
import { Avatar } from "../../../../design/avatar";

const integrations = [
  {
    _id: "clio",
    name: "Clio",
    description: "Sync your Clio data with CaseTime",
    logoUrl:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTX0YbBllnistE3mPmu8ExuTVTA2vT92afJBQ&s",
  },
];

export default function IntegrationsHomePage() {
  return (
    <div>
      <Breadcrumbs
        items={[
          { label: "Settings", href: "/settings" },
          { label: "Integrations", href: "/settings/integrations" },
        ]}
      />

      <Heading>Integrations</Heading>
      <Subheading>Sync your data with third-party applications</Subheading>
      <Divider className="my-4" />
      <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {integrations.map((integration) => (
          <Link
            className="flex items-center gap-4"
            href="/settings/integrations/clio"
            key={integration._id}
          >
            <Avatar src={integration.logoUrl} className="w-12 h-12" />
            <div className="flex flex-col gap-2">
              <Heading>{integration.name}</Heading>
              <Subheading>{integration.description}</Subheading>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
